import { forwardRef } from "react";
import { Typography } from "antd";
import classNames from "classnames";
import type { TextProps } from "antd/lib/typography/Text";
import type { TextSize, TextWeight, TextType, TextLineHeight } from "../types";
import styles from "./styles.module.scss";

const { Text } = Typography;

type Props = {
  textType?: TextType;
  weight?: TextWeight;
  size?: TextSize;
  lineHeight?: TextLineHeight;
} & TextProps;

export const AppText = forwardRef<HTMLElement, Props>(
  ({ className, type = "default", weight, size, lineHeight, ...props }, ref) => {
    return (
      <Text
        ref={ref}
        className={classNames([
          styles[`type-${type}`],
          styles[`size-${size}`],
          styles[`weight-${weight}`],
          styles[`line-height-${lineHeight}`],
          className,
        ])}
        {...props}
      />
    );
  },
);
